import { createAction, props } from "@ngrx/store";

export const cargaAcuerdo = createAction("[Acuerdo Component] cargaAcuerdo", props<{ oAcuerdo: any }>());
export const cargaAcuerdoCampos = createAction('[Acuerdo Component] cargaAcuerdoCampos', props<{ oData: any }>());
export const resetAcuerdo = createAction("[Acuerdo Component] resetAcuerdo");
